// check if cart is empty or not
function checkIfCartIsEmpty(variantID,productID,wishlistRemoveVarId) {
  let cartItems = document.querySelectorAll('.custom-cart-item[data-id="custom-cart-item"]');
  if (cartItems.length > 0) {
    checkVariantInCart(variantID, cartItems, productID, wishlistRemoveVarId);
  } else {
    variantNotFoundInCart(variantID,productID,wishlistRemoveVarId);
  }
}

// check if the product already exists in the cart
function checkVariantInCart(variantID, cartItems, productID, wishlistRemoveVarId) {
  let variantFoundInCart = null;
  cartItems.forEach((item) => {
    if (item.getAttribute("cart-variant-id") == variantID) variantFoundInCart = item;
  });
  if (variantFoundInCart) {
    getVariantStatus(variantFoundInCart, productID, variantID, wishlistRemoveVarId);
  } else {
    variantNotFoundInCart(variantID, productID, wishlistRemoveVarId);
  }
}

// check the current value quantity of variant in cart
function getVariantStatus(variantFoundInCart,productID,variantID,wishlistRemoveVarId) {
  let currentVariantQty = Number(variantFoundInCart.getAttribute("cart-qty"));
  let inventoryQty = Number(variantFoundInCart.getAttribute("cart-variant-inventory"));
  let cartKey = variantFoundInCart.getAttribute("cart-variant-key");
  if (currentVariantQty + 1 <= inventoryQty && currentVariantQty + 1 <= 10) {
    updateVariantInCart(cartKey, currentVariantQty + 1, productID, variantID, wishlistRemoveVarId);
  } else {
    wishMaxQuantityMsg()
  }
}

// Update variant in cart
function updateVariantInCart(cartKey,newQty,productID,variantID,wishlistRemoveVarId) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: cartKey,
      quantity: newQty,
    }),
  })
    .then((resp) => resp.json())
    .then((data) => {
      console.log(data, "data");
      removeProduct(productID,wishlistRemoveVarId);
      updateCart();
      addToCartGTMEvent(data);
      showUpdateMsg();
      if (screen.width > 768) {
        setTimeout(() => {
          showCartRecommendations();
        }, "3000");
      }
    });
}

function variantNotFoundInCart(variantID,productID,wishlistRemoveVarId) {
  var data = {
    items: [
      {
        quantity: 1,
        id: variantID
      }
    ]
  };
  fetch('/cart/add.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  }).then(response => {
    return response.json();
  }).then(data => {
    removeProduct(productID,wishlistRemoveVarId);
    updateCart();
    addToCartGTMEvent(data);
    showUpdateMsg();
  }).catch((error) => {
    console.error('Error:', error);
  });
}


function wishMaxQuantityMsg() {
  let msgDiv = document.querySelector(".product-addedNotification");
  let msg = msgDiv.querySelector(".product-addedNotification .notification-tag");
  msg.innerText = "The max quantity of product is already in your bag.";
  msgDiv.style.display = "flex";
  msgDiv.style.zIndex = "5";
  setTimeout(wishRemoveMsg, 2000);
}

function showUpdateMsg() {
  let msgDiv = document.querySelector(".product-addedNotification");
  let msg = msgDiv.querySelector(".product-addedNotification .notification-tag");
  msg.innerText = "The product is added in your bag.";
  msgDiv.style.display = "flex";
  msgDiv.style.zIndex = "5";
  setTimeout(wishRemoveMsg, 2000);
}

function wishRemoveMsg() {
  let msgDiv = document.querySelector(".product-addedNotification");
  msgDiv.style.display = "none";
}